// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file common/v3/common.proto (package common.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumOptions, EnumValueOptions, FieldOptions, MessageOptions, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v3/common.proto.
 */
export const file_common_v3_common: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_descriptor]);

/**
 * The Attribution message is used to represent the attribution of a user to
 * an action or event that has occurred.
 *
 * @generated from message common.v3.UserAttribution
 */
export type UserAttribution = Message<"common.v3.UserAttribution"> & {
  /**
   * The ID of the user attributed to the action or event.
   * Format: ^user_[a-z0-9]{20}$
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * The display name of the user attributed to the action or event.
   *
   * @generated from field: string user_display_name = 2;
   */
  userDisplayName: string;

  /**
   * The URL of the user's avatar.
   *
   * @generated from field: optional string user_avatar_url = 3;
   */
  userAvatarUrl?: string;

  /**
   * The email of the user attributed to the action or event. May be redacted.
   *
   * @generated from field: optional string user_email = 4;
   */
  userEmail?: string;

  /**
   * Field 4: The timestamp when the attribution occurred.
   *
   * @generated from field: google.protobuf.Timestamp occurred_at = 5;
   */
  occurredAt?: Timestamp;
};

/**
 * Describes the message common.v3.UserAttribution.
 * Use `create(UserAttributionSchema)` to create a new message.
 */
export const UserAttributionSchema: GenMessage<UserAttribution> = /*@__PURE__*/
  messageDesc(file_common_v3_common, 0);

/**
 * AuditMetadata represents the complete lifecycle history of an entity,
 * tracking who created it, last modified it, and optionally who deleted it.
 *
 * @generated from message common.v3.AuditMetadata
 */
export type AuditMetadata = Message<"common.v3.AuditMetadata"> & {
  /**
   * Attribution information for the user who created this entity.
   * Always required and populated upon entity creation.
   *
   * @generated from field: common.v3.UserAttribution created = 1;
   */
  created: UserAttribution;

  /**
   * Attribution information for the user who last modified this entity.
   * Always required and initially set to the same value as created.
   *
   * @generated from field: common.v3.UserAttribution modified = 2;
   */
  modified: UserAttribution;

  /**
   * Attribution information for the user who deleted this entity, if applicable.
   * When present, indicates the entity has been deleted.
   *
   * @generated from field: optional common.v3.UserAttribution deleted = 3;
   */
  deleted: UserAttribution;
};

/**
 * Describes the message common.v3.AuditMetadata.
 * Use `create(AuditMetadataSchema)` to create a new message.
 */
export const AuditMetadataSchema: GenMessage<AuditMetadata> = /*@__PURE__*/
  messageDesc(file_common_v3_common, 1);

/**
 * Share message is used to define the sharing settings for a resource.
 * Sharing allows for access outside of the boundaries established by
 * a realm.
 *
 * @generated from message common.v3.Share
 */
export type Share = Message<"common.v3.Share"> & {
  /**
   * The public secret for the realm.
   *
   * @generated from field: optional string public_secret = 1;
   */
  publicSecret?: string;

  /**
   * The private secret for the realm.
   *
   * @generated from field: optional string private_secret = 2;
   */
  privateSecret?: string;

  /**
   * Indicates if the realm is publicly indexed.
   *
   * @generated from field: optional bool public_indexed = 3;
   */
  publicIndexed?: boolean;

  /**
   * format: ^realm_[a-z0-9]{20}$
   *
   * List of user IDs with access.
   *
   * @generated from field: repeated string user_id_list = 4;
   */
  userIdList: string[];

  /**
   * List of team IDs with access.
   *
   * @generated from field: repeated string team_id_list = 5;
   */
  teamIdList: string[];
};

/**
 * Describes the message common.v3.Share.
 * Use `create(ShareSchema)` to create a new message.
 */
export const ShareSchema: GenMessage<Share> = /*@__PURE__*/
  messageDesc(file_common_v3_common, 2);

/**
 * SortOrder defines the sort order for query results
 *
 * @generated from enum common.v3.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Ascending order (A-Z, 1-9, oldest-newest)
   *
   * @generated from enum value: SORT_ORDER_ASCENDING = 1;
   */
  ASCENDING = 1,

  /**
   * Descending order (Z-A, 9-1, newest-oldest)
   *
   * @generated from enum value: SORT_ORDER_DESCENDING = 2;
   */
  DESCENDING = 2,
}

/**
 * Describes the enum common.v3.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_common_v3_common, 0);

/**
 * Optional flag to indicate that the feature is a model feature.
 *
 * @generated from extension: optional bool is_model_feature = 50001;
 */
export const is_model_feature: GenExtension<EnumValueOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 0);

/**
 * @generated from extension: optional bool enum_model_feature_only = 50002;
 */
export const enum_model_feature_only: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 1);

/**
 * The field_id is a string identifier for the field, used for additional type safety
 *
 * @generated from extension: string field_id = 50003;
 */
export const field_id: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_common_v3_common, 2);

/**
 * @generated from extension: bool required = 50000;
 */
export const required: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 3);

/**
 * Hint to guide the LLM in generating appropriate content for this field
 *
 * @generated from extension: string llm_hint = 50009;
 */
export const llm_hint: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_common_v3_common, 4);

/**
 * If true, this field will be omitted from the generated JSON schema
 *
 * @generated from extension: bool omit_from_schema = 50010;
 */
export const omit_from_schema: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 5);

/**
 * Optional flag to indicate that the feature is a chat style.
 *
 * @generated from extension: optional bool is_chat_style = 50004;
 */
export const is_chat_style: GenExtension<EnumValueOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 6);

/**
 * Optional flag to indicate that the feature is a chat prompt method.
 *
 * @generated from extension: optional bool is_chat_prompt_method = 50006;
 */
export const is_chat_prompt_method: GenExtension<EnumValueOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 7);

/**
 * Optional flag to indicate that the feature is a chat tool.
 *
 * @generated from extension: optional bool is_tool = 50007;
 */
export const is_tool: GenExtension<EnumValueOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 8);

/**
 * Hint to guide the LLM in generating appropriate content for this enum value
 *
 * @generated from extension: string llm_enum_hint = 50011;
 */
export const llm_enum_hint: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_common_v3_common, 9);

/**
 * If true, this enum value will be ignored when generating JSON schemas
 *
 * @generated from extension: bool ignore_enum_in_schema = 50012;
 */
export const ignore_enum_in_schema: GenExtension<EnumValueOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 10);

/**
 * Description for the entire enum type, used in JSON schema generation
 *
 * @generated from extension: string llm_enum_description = 50013;
 */
export const llm_enum_description: GenExtension<EnumOptions, string> = /*@__PURE__*/
  extDesc(file_common_v3_common, 11);

/**
 * If true, this entire enum will be omitted from JSON schema generation
 *
 * @generated from extension: bool omit_enum_from_schema = 50014;
 */
export const omit_enum_from_schema: GenExtension<EnumOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 12);

/**
 * @generated from extension: optional bool enum_chat_style_only = 50005;
 */
export const enum_chat_style_only: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 13);

/**
 * Marks a field as containing sensitive data requiring encryption
 *
 * @generated from extension: bool sensitive = 50008;
 */
export const sensitive: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 14);

/**
 * If true, generate a JSON schema for this message
 *
 * @generated from extension: bool generate_schema = 50000;
 */
export const generate_schema: GenExtension<MessageOptions, boolean> = /*@__PURE__*/
  extDesc(file_common_v3_common, 15);

/**
 * Optional output path for the schema (relative to repo root)
 * If not set, will use default path: pkg/go/domains/cp/services/v3/agent/workflows/data/schemas/{MessageName}.schema.gen.txt
 *
 * @generated from extension: string schema_output_path = 50001;
 */
export const schema_output_path: GenExtension<MessageOptions, string> = /*@__PURE__*/
  extDesc(file_common_v3_common, 16);

